import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const TextAreaInput = ({
  input,
  meta: {
    touched,
    error,
    warning
  },
  required,
  hideHints,
  placeholder,
  type,
  className
}) => (
  <div>
    <textarea
      type={ type }
      { ...input }
      placeholder={ placeholder }
      className={ `${ className } ${ touched && error && 'is-error' }` }
      required={ required }
      autoComplete="off"
    />
    {
      !hideHints && touched && (
        (error && <p className="form-input-hint">{ error }</p>)
        || (warning && <p className="form-input-hint">{ warning }</p>)
      )
    }
  </div>
);

TextAreaInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
    warning: PropTypes.any
  }).isRequired,
  required: PropTypes.bool,
  hideHints: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string
};

TextAreaInput.defaultProps = {
  required: false,
  hideHints: false,
  placeholder: '',
  type: 'text',
  className: ''
};
